// Add a closing X button to elements with classes "closable", "closable-tr", or "closable-r"
document.addEventListener("DOMContentLoaded", function() {
    // Add close button to all elements with the specified classes
    function addCloseButton(element, position) {
        const closeButton = document.createElement("span");
        closeButton.textContent = "✘";
        closeButton.style.position = "absolute";
        closeButton.style.cursor = "pointer";

        // Tailwind classes
        closeButton.classList.add(
            "btn-closing-x"
        );

        // Define position styles for close button
        if (position === "top-right") {
        }
        else if (position === "right-centered") {
            closeButton.style.top = "50%";
            closeButton.style.transform = "translateY(-50%)";
        }

        // Append close button to the element
        element.style.position = "relative";  // Make sure the container is positioned relatively
        element.appendChild(closeButton);

        // Remove element when close button is clicked
        closeButton.addEventListener("click", function() {
            element.remove();
        });
    }

    // Apply close button behavior based on class
    document.querySelectorAll(".closable, .closable-tr, .closable-r").forEach(element => {
        if (element.classList.contains("closable-tr")) {
            addCloseButton(element, "top-right");
        }
        else if (element.classList.contains("closable-r")) {
            addCloseButton(element, "right-centered");
        }
        else {
            const elementHeight = element.offsetHeight;
            if (elementHeight <= 40) {
                addCloseButton(element, "right-centered");
            }
            else {
                addCloseButton(element, "top-right");
            }
        }
    });
});
